import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface PinDisplayProps {
  value: string;
  maxLength?: number;
  variant?: 'blue' | 'amber';
  isError?: boolean;
  className?: string;
  compact?: boolean;
}

export const PinDisplay: React.FC<PinDisplayProps> = ({
  value,
  maxLength = 6,
  variant = 'blue',
  isError = false,
  className,
  compact = false
}) => {
  const filledColor = variant === 'amber' 
    ? 'bg-amber-400' 
    : 'bg-blue-500';
  
  const filledBgColor = variant === 'amber'
    ? 'rgba(245, 158, 11, 0.3)'
    : 'rgba(59, 130, 246, 0.3)';

  return (
    <div className={cn(
      "flex justify-center",
      compact ? "gap-1.5 sm:gap-2" : "gap-2 sm:gap-3",
      className
    )}>
      {Array.from({ length: maxLength }).map((_, i) => (
        <motion.div
          key={i}
          initial={{ scale: 0.8 }}
          animate={{ 
            scale: value[i] ? 1.1 : 1,
            backgroundColor: isError 
              ? 'rgba(239, 68, 68, 0.3)' 
              : value[i] 
                ? filledBgColor 
                : 'rgba(255, 255, 255, 0.1)'
          }}
          className={cn(
            "rounded-lg sm:rounded-xl border-2 flex items-center justify-center",
            compact ? "w-10 h-10 sm:w-12 sm:h-12" : "w-11 h-11 sm:w-14 sm:h-14",
            isError ? "border-red-500/50" : "border-white/20"
          )}
        >
          {value[i] ? (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className={cn(
                "rounded-full",
                compact ? "w-3 h-3" : "w-3 h-3 sm:w-4 sm:h-4",
                isError ? "bg-red-400" : filledColor
              )}
            />
          ) : null}
        </motion.div>
      ))}
    </div>
  );
};
